import log from "loglevel";
import React, { useState, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button, FormControl } from 'react-bootstrap';
import httpService from 'services/httpService';
import * as constants from "Constants";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";


const EditableCell = ({ modifyAll, studentId, studentsResponseData, setStudentsResponseData, examId, fetchData = null }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(0);

    const handleEdit = () => setIsEditing(true);

    const handleClose = () => {
        setIsEditing(false);
        setValue(0);
    }

    const ModifyTime = useCallback(async (e, modifyAll, studentId, timedelta, examId, studentsResponseData, setStudentsResponseData) => {
        try {
            if (timedelta === 0) {
                displayGlobalMessage("Please enter a valid time", "error");
                return;
            }
            if (modifyAll) {
                // Modify time for all students
                const response = await httpService.put(`${constants.base_url}/exam/${examId}/proctor/modifytime/all`, { time_delta: timedelta });
                displayGlobalMessage("Time updated successfully!!", "success");
                handleClose();
                // setStudentsResponseData(response.data.student_exam);
                fetchData?.();
            } else {
                // Modify time for a specific student
                const _response = await httpService.put(`${constants.base_url}/exam/${examId}/proctor/modifytime/${studentId}`, { time_delta: timedelta });
                displayGlobalMessage("Time updated successfully", "success");
                fetchData?.();
                handleClose();
                // setStudentsResponseData(prevData =>
                //     prevData.map(student => {
                //         if (student.student_id === studentId) {
                //             // Make sure to not directly mutate state
                //             return {
                //                 ...student,
                //                 added_time: parseInt(student.added_time) + (timedelta * 60),
                //                 duration: `${Math.floor(moment.duration(student.duration).asDays())} ${moment.duration(student.duration).hours().toString().padStart(2, '0')}:${moment.duration(student.duration).minutes().toString().padStart(2, '0')}:${moment.duration(student.duration).seconds().toString().padStart(2, '0')}`
                //             };
                //         }
                //         return student;
                //     })
                // );
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                if (error.response.data.error) {
                    displayGlobalMessage(error.response.data.error, "error");
                } else {
                    displayGlobalMessage("Exam has ended, Can't add time now", "error");
                }
            } else {
                log.error(error);
                displayGlobalMessage("An error occurred while modifying time", "error");
            }
        }
    }, [handleClose]);

    const handleAdd = (e) => {
        // e.preventDefault();
        ModifyTime(e, modifyAll, studentId, value, examId, studentsResponseData, setStudentsResponseData, handleClose);
    };

    const handleReduce = (e) => {
        // e.preventDefault();
        ModifyTime(e, modifyAll, studentId, -1 * value, examId, studentsResponseData, setStudentsResponseData, handleClose);
    };

    return (
        <td>
            {isEditing ? (
                <Container>
                    <Row style={{ display: 'flex' }}>
                        <Col>
                            <div className="input-group" style={{ flex: 1 }}>
                                <FormControl
                                    type="number"
                                    value={value}
                                    onChange={e => setValue(Number(e.target.value))}
                                    className="form-control"
                                    min="0"
                                    aria-label="Edit value"
                                />
                                <div className="input-group-append ml-2" style={{ flex: 1 }}>
                                    <Button
                                        variant="light"
                                        style={{ fontWeight: 'bold' }}
                                        onClick={handleClose}
                                        aria-label="Close edit"
                                    >
                                        &times;
                                    </Button>
                                </div>
                            </div>
                            <div className="d-flex mt-2">
                                <Button
                                    variant="primary"
                                    onClick={handleAdd}
                                    aria-label="Add value"
                                >
                                    Add
                                </Button>
                                <Button
                                    variant="secondary"
                                    className="ml-2"
                                    onClick={handleReduce}
                                    aria-label="Reduce value"
                                >
                                    Reduce
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={handleEdit}
                    aria-label="Edit value"
                >
                    {value}
                </span>
            )}
        </td>
    );
};

EditableCell.propTypes = {
    modifyAll: PropTypes.bool.isRequired,
    studentId: PropTypes.string.isRequired,
};

export default memo(EditableCell);
